export const SET_NOTIFICATION_EVENTS = "SET_NOTIFICATION_EVENTS";
export const SET_RECIPIENT_ROLES = "SET_RECIPIENT_ROLES";
export const SET_NOTIFICATION_ERROR = "SET_NOTIFICATION_ERROR";
export const SET_NOTIFICATION_TAGS = "SET_NOTIFICATION_TAGS";
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const SET_EDIT_DATA = "SET_EDIT_DATA";
